import { batch, useSignal } from '@preact/signals'
import { Text } from 'preact-i18n'
import { Suspense, lazy } from 'preact/compat'
import type { StepTour } from '../molecules/Tour'

import { CookieManager } from '../../utils'

const Tour = lazy(() => import('../molecules/Tour'))
const TutorialModal = lazy(() => import('../molecules/TutorialModal'))

const tutorialSteps: StepTour[] = [
  {
    selector: '#barcodes',
    content: <Text id="tutorial.steps.step1" />,
    position: 'bottom left',
  },
  {
    selector: '#camera',
    content: <Text id="tutorial.steps.step2" />,
    position: 'bottom left',
  },
  {
    selector: '#soundEffects',
    content: <Text id="tutorial.steps.step3" />,
    position: 'bottom center',
  },
  {
    selector: '#duplicateFilter',
    content: <Text id="tutorial.steps.step4" />,
    position: 'bottom right',
  },
  {
    selector: '#barcodesList',
    content: <Text id="tutorial.steps.step5" />,
    position: 'top center',
    basic: true,
  },
]
const COOKIE_NAME = 'tutorial_seen'
const noop = () => void 0

type TutorialProps = {
  onNextTip?: () => void
  onConfirmAction?: () => void
  onFinish?: () => void
}

const Tutorial = ({ onNextTip = noop, onConfirmAction = noop, onFinish = noop }: TutorialProps) => {
  const finished = useSignal(false)
  const stepIndex = useSignal(-1)
  const tutorialModalOpen = useSignal(CookieManager.get(COOKIE_NAME) !== 'y')

  return CookieManager.get(COOKIE_NAME) !== 'y' ? (
    <Suspense fallback={null}>
      <TutorialModal
        tutorialFinished={finished.value}
        open={tutorialModalOpen.value}
        onNextTip={() => {
          stepIndex.value += 1
          onNextTip()
        }}
        onConfirmAction={() => {
          batch(() => {
            stepIndex.value = -1
            tutorialModalOpen.value = false
            CookieManager.set(COOKIE_NAME, 'y', 365)
            onConfirmAction()
          })
        }}
      />
      {/** @ts-ignore */}
      <Tour
        steps={tutorialSteps}
        stepIndex={stepIndex.value}
        onFinish={() => {
          stepIndex.value = -1
          finished.value = true
          onFinish()
        }}
      />
    </Suspense>
  ) : null
}

export default Tutorial
